import React, { useContext } from "react";
import styles from "./index.module.scss";
import { Button, Icon, Tag } from "antd";
import Space from "../../../../../components/Space";
import classNames from "classnames";
import UserAvatar from "../../../Components/UserAvatar";
import TopicManage from "./Components/TopicManage";
import { DiscussContent } from "../../context";
import { SpeakerType, TopicType } from "../../../../../service/discuss";
import TimeLimit from "./Components/TimeLimit";
import lodash from "lodash-es";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";

interface TopicProps {
    isFollow: boolean; // 是否已关注
}

export default function Topic({ isFollow }: TopicProps) {
    const { discussDetail, course, setIsWriting, topicType, setEditUuid } =
        useContext(DiscussContent);
    const { speakerType, speakerNo, speakerName } = discussDetail || {};

    function onEditOk() {
        window.location.reload();
    }

    function onWrite() {
        if (topicType === TopicType.Discuss) {
            const answer = lodash.find(discussDetail?.replies, {
                canEdit: "1",
                delStatus: 0
            });

            if (answer) {
                setEditUuid(answer.uuid);
            } else {
                setEditUuid(null);
            }
        }
        setIsWriting(true);
    }

    const history = useHistory();

    return (
        <div id="DiscussTopic" className={classNames("container", styles.root)}>
            <div className={styles.body}>
                <Space className={styles.tags}>
                    <Tag color="blue">{course?.courseName}</Tag>
                    <Button
                        className="back"
                        size="small"
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </Space>

                <h1 className={styles.title}>
                    <UserAvatar
                        placement="bottomLeft"
                        isTeacher={speakerType === SpeakerType.Teacher}
                        userNo={speakerNo || ""}
                        userName={speakerName || ""}
                    />
                    {discussDetail?.topicName}
                </h1>

                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html: discussDetail?.topicContent || ""
                    }}
                />

                {discussDetail && <TimeLimit data={discussDetail} />}
            </div>

            <div className={styles.tools}>
                <Space className={styles.buttons} size={10}>
                    <Button icon="edit" onClick={onWrite}>
                        写回答
                    </Button>
                </Space>

                <Space className={styles.statics} size={20}>
                    <span>
                        <Icon type="solution" />
                        &nbsp;
                        {discussDetail?.statics?.partInCount}
                        人参与
                    </span>

                    <span>
                        <Icon type="message" />
                        &nbsp;
                        {discussDetail?.statics?.replyCount || 0} 条发言
                    </span>

                    <TopicManage onEditOk={onEditOk} />
                </Space>
            </div>
        </div>
    );
}
